import client from "../Client/HttpClient";
import {ICourseGroupsModel} from "@/interfaces/modules";
const ApiPath = "CourseGroups";

export default {
    GetCourseGroups:() : Promise <ICourseGroupsModel[]> => client.get(`${ApiPath}`),
    GetCourseGroupsbyId: (data: any): Promise <ICourseGroupsModel> => client.get(`${ApiPath}/${data.Id}`), 
    PostCourseGroups: (data: any): Promise<ICourseGroupsModel> => client.post(`${ApiPath}`, data)
  };

  